import request from '@/utils/request'

export function fetchHotCity(params) {
  return request({
    url: 'api/region/hotCityList',
    method: 'get',
    params: params
  })
}